import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  OnInit,
  input,
  computed,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { AsyncPipe, NgClass } from '@angular/common';
import { take } from 'rxjs';
import * as uuid from 'uuid';
import { FormsModule } from '@angular/forms';
import { FloatingInputComponent } from '@app/framework/inputs/floating-input/floating-input.component';
import { AddRemoveButtonsComponent } from '@app/framework/buttons/add-remove-buttons/add-remove-buttons.component';
import { DropdownComponent } from '@app/framework/inputs/dropdown/dropdown.component';
import { primeSelectors } from '@app/store/prime-commitments/prime-commitments.selectors';
import { PCOLineItemGroup } from '@app/store/prime-commitments/prime-commitments.types';
import { emptyPCODescription } from '@app/store/prime-commitments/prime-commitments.constants';

@Component({
  selector: 'app-pco-new-scope-entry',
  imports: [
    FloatingInputComponent,
    AddRemoveButtonsComponent,
    DropdownComponent,
    AsyncPipe,
    NgClass,
    FormsModule,
  ],
  templateUrl: './pco-new-scope-entry.component.html',
  styleUrl: './pco-new-scope-entry.component.scss',
})
export class PcoNewScopeEntryComponent implements OnInit {
  private readonly store = inject(Store);
  protected readonly tempUUID = uuid.v4();
  @Input({ required: true }) entryIndex: number;
  @Input({ required: true }) lineItem: PCOLineItemGroup;
  allLineItemGroups = input<PCOLineItemGroup[]>([]);
  @Output() lineItemsChange = new EventEmitter<PCOLineItemGroup>();

  lineItemGroupIds = computed(() => {
    return this.allLineItemGroups().map((group) => group.id);
  });

  lineItemOptions$ = this.store.select(primeSelectors.selectAllLineItemsUsedInPrimeContract);

  ngOnInit() {
    console.log(this.lineItem);
  }

  descriptionChange(spendDescription: string, index: number) {
    this.lineItem.descriptions[index].spend_description = spendDescription;
    this.lineItemsChange.emit(this.lineItem);
  }

  budgetDollarsChange(budgetDollars: string, index: number) {
    this.lineItem.descriptions[index].budget_dollars = Number(budgetDollars);
    this.lineItemsChange.emit(this.lineItem);
  }

  removeDescription(index: number) {
    this.lineItem.descriptions.splice(index, 1);
    this.lineItemsChange.emit(this.lineItem);
  }

  addDescription(index: number) {
    this.lineItem.descriptions.splice(index + 1, 0, { ...emptyPCODescription });
    this.lineItemsChange.emit(this.lineItem);
  }

  lineItemChange(id: number) {
    this.lineItemOptions$.pipe(take(1)).subscribe((nonMarkupLines) => {
      const lineItem = nonMarkupLines.find((line) => line.id === id);
      this.lineItemsChange.emit({
        ...lineItem,
        descriptions: this.lineItem.descriptions,
      });
    });
  }
}
